import { curry, type PlatformEvent } from 'lib/util'

/**
 * Sets the action's `stopMeasurement` state so that a measurement in progress is stopped.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 */
const stopMeasurement = async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: PlatformEvent,
) => {
  const actionState = module[G.STATE][G.ACTION][G.STATE]

  if (actionState.measuring) {
    actionState.stopMeasurement = true

    return await new Promise((resolve, reject) => {
      actionState.onMeasurementStopped = (success: boolean) => success ? resolve(success) : reject()
    })
  }
}

export default curry(stopMeasurement)
